const style = {
  debug: "color: #888; font-style: italic;",
  info: "color: #7BB7FF;",
  warn: "color: #CC9900; font-weight: bold;",
  error: "color: #CC0000; font-weight: bold;",
};

// const originalConsoleLog = console.log;
// const originalConsoleError = console.error;
//
// console.warn = function (module: string, message: string, ...args) {
//   originalConsoleLog(`%c[${module}]`, style["warn"], message, ...args);
// };
// console.log = function (module: string, message: string, ...args) {
//   originalConsoleLog(`%c[${module}]`, style["info"], message, ...args);
// };
// console.error = function (module: string, message: string, ...args) {
//   originalConsoleError(`%c[${module}]`, style["error"], message, ...args);
// };

export const createLogger = (module: string) => {
  return {
    // @ts-expect-error "imporpoer types"
    info: (message, ...args) =>
      console.log(`%c[${module}]`, style["info"], message, ...args),
  };
};
